// eslint-disable-next-line eslint-comments/disable-enable-pair
// https://lastbrand.atlassian.net/browse/ECOMP-4497
import { CONFIG_BUY_NOW_REDIR_DOMAIN } from '@src/config/env'
import { getStorage } from '@src/utils/enhancedStorage'

import AuthUtil from '../../utils/authUtil'
import isBrowser from '../../utils/isBrowser'
import { storedCartRegionMatchesCurrent } from '../cartService/cart.service.helper'
import { TBuyNowApiResponse } from '../cartService/cart.service.types'
import { createLocalePrefixedCheckoutUrl } from '../checkoutService/checkoutUrl.helper'

import { getOrCreateCheckout } from './cart.service'
import { getCheckoutWithId, getIsCheckoutActive } from './checkout.service'
import { removeCheckoutIdFromLocalStorage } from './checkout.service.helper'
import {
  CART_CHECKOUT_ID_KEY,
  CART_CHECKOUT_OBJ_KEY,
  LOCAL_STORAGE_CART_OBJ_KEY,
  LOCAL_STORAGE_NEW_CART_ID_KEY,
  LOCAL_STORAGE_PREV_CART_ID_KEY,
  LOCAL_STORAGE_PREV_CHECKOUT_ID_KEY,
} from './constants'

export const updateNewCheckoutInLocalStorage = (data: any) => {
  if (data?.id) {
    getStorage().setItem(LOCAL_STORAGE_NEW_CART_ID_KEY, data?.cart?.id || '', { isGlobal: false })
    getStorage().setItem(LOCAL_STORAGE_CART_OBJ_KEY, JSON.stringify(data?.cart), { isGlobal: false })
    getStorage().setItem(CART_CHECKOUT_ID_KEY, data.id || '', { isGlobal: false })
    getStorage().setItem(CART_CHECKOUT_OBJ_KEY, JSON.stringify(data), { isGlobal: false })
  }
}
export const getPrevCartId = () => {
  return getStorage().getItem(LOCAL_STORAGE_PREV_CART_ID_KEY, { isGlobal: false })
}
export const deletePrevCartId = () => {
  getStorage().removeItem(LOCAL_STORAGE_PREV_CART_ID_KEY, { isGlobal: false })
}
export const getCartId = () => {
  return getStorage().getItem<string>(LOCAL_STORAGE_NEW_CART_ID_KEY, { isGlobal: false })
}

export const getPrevCheckoutId = () => {
  return getStorage().getItem<string>(LOCAL_STORAGE_PREV_CHECKOUT_ID_KEY, { isGlobal: false })
}

export const deletePrevCheckoutId = () => {
  getStorage().removeItem(LOCAL_STORAGE_PREV_CHECKOUT_ID_KEY, { isGlobal: false })
}

export const getCheckoutId = () => {
  const checkoutId = getStorage().getItem<string>(CART_CHECKOUT_ID_KEY, { isGlobal: false })
  if (checkoutId) {
    return checkoutId
  }
  return null
}
export const getNewCheckoutFromLocalStorage = () => {
  let cartString: string | null = ''
  if (isBrowser()) {
    if (getStorage().getItem(LOCAL_STORAGE_NEW_CART_ID_KEY, { isGlobal: false })) {
      cartString = getStorage().getItem(LOCAL_STORAGE_CART_OBJ_KEY, { isGlobal: false })
    } else {
      getStorage().removeItem(LOCAL_STORAGE_CART_OBJ_KEY, { isGlobal: false })
    }
  }
  let checkout
  if (cartString) {
    try {
      checkout = JSON.parse(cartString)
    } catch (error) {
      console.error('Error occured on getCheckoutFromLocalStorage: ', error)
    }
  }
  return checkout
}
export const getNewCartData = async () => {
  const isLoggedIn = AuthUtil.isLoggedIn()
  let result = []
  if (isLoggedIn) {
    const data = await getIsCheckoutActive()
    result = data
  } else {
    const checkoutId = getCheckoutId()
    const cartId = getCartId()
    if (checkoutId) {
      if (!storedCartRegionMatchesCurrent()) {
        return
      }
      const data = await getCheckoutWithId(checkoutId)
      if (data?.cartStatus !== 'ACTIVE') {
        removeCheckoutIdFromLocalStorage()
        return
      }
      result = data
    } else if (cartId) {
      if (!storedCartRegionMatchesCurrent()) {
        return
      }
      const createdCheckout = await getOrCreateCheckout(cartId)
      const data = await getCheckoutWithId(createdCheckout?.checkoutId)
      if (data?.cartStatus !== 'ACTIVE') {
        removeCheckoutIdFromLocalStorage()
        return
      }
      result = data
    }
  }
  return result
}

export const getCheckoutUrlFromBuyNowRes = (
  response: TBuyNowApiResponse | undefined,
  showNewDesign: boolean,
  hideAuthCode = false,
) => {
  if (!response?.buyNowCartCheckoutMapping) return ''
  const {
    buyNowCartCheckoutMapping: { checkoutId, checkoutAuthCode },
  } = response

  if (!checkoutId) return ''
  if (!hideAuthCode && !checkoutAuthCode) return ''

  // Create locale-prefixed checkout URL
  return createLocalePrefixedCheckoutUrl(
    CONFIG_BUY_NOW_REDIR_DOMAIN,
    checkoutId,
    checkoutAuthCode,
    showNewDesign,
    false,
    false,
    undefined,
    false,
    undefined,
    hideAuthCode,
  )
}

export const formatToYYYYMMDD = (dateStr: string): string => {
  // Convert "MM/DD/YYYY" to "YYYY-MM-DD"
  const parts = dateStr.replace(/ /g, '/').split('/')
  if (parts.length < 3) throw new Error(`Invalid date format. Expected MM/DD/YYYY`)

  const [month, day, year] = parts.map(Number) as [number, number, number]
  const date = new Date(Date.UTC(year, month - 1, day))
  return date.toISOString().split('T')[0] ?? ''
}
